interface IconProps {
  color?: string
}

export const Passkey = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 17.5V12.25C4.75 7.69 8.44 4 13 4C17.56 4 21.25 7.69 21.25 12.25V16"
        stroke={color ?? 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 21V12.25C9 10.04 10.79 8.25 13 8.25C15.21 8.25 17 10.04 17 12.25V19.5"
        stroke={color ?? 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M13 13V22" stroke={color ?? 'currentColor'} strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}
